<template>
	<div class="themes">
		<ButtonTheme v-for="theme in themes" :theme="theme" :key="theme.name" />
	</div>
</template>

<script>
import { mapState } from 'vuex'
import ButtonTheme from '@/components/UI/ButtonTheme.vue'

export default {
	name: 'themes',

	components: {
		ButtonTheme
	},

	computed: {
		...mapState({
			themes: (state) => state.data.themes
		})
	}
}
</script>

<style lang="scss" scoped>
.themes {
	display: grid;

	@include media('<=phone') {
		grid-template-columns: repeat(2, 1fr);
		gap: 4vw;
	}

	@include media('>phone') {
		gap: 20px;
		grid-template-columns: repeat(2, 1fr);
	}
}
</style>
